/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_NoteInputs */

const en_home_hero_note = /** @type {(inputs: Home_Hero_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agreed limits. Every run recorded. A named person for exceptions.`)
};

const lv_home_hero_note = /** @type {(inputs: Home_Hero_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņotas robežas. Katra darbība pierakstīta. Izņēmumus izlemj cilvēks.`)
};

/**
* | output |
* | --- |
* | "Agreed limits. Every run recorded. A named person for exceptions." |
*
* @param {Home_Hero_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_note = /** @type {((inputs?: Home_Hero_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_note(inputs)
	return en_home_hero_note(inputs)
});